import { NamedError } from '../utils/Errors'

export enum FileUploadForegroundTaskErrors {
    UnsupportedFileFormat = 'UnsupportedFileFormat'
}

export class FileUploadForegroundTaskError extends NamedError<FileUploadForegroundTaskErrors> {}